<template>
    <ToggleButton
        :key="eventId"
        :selected="isSaved"
        :class="{ 'toggle-button--icon-only': iconOnly }"
        class="event-follow-button toggle-button--light"
        @input="submit"
    >
        {{ iconOnly ? '' : 'Wil ik heen' }}
    </ToggleButton>
</template>

<script setup lang="ts">
const props = withDefaults(
    defineProps<{
        eventId: number;
        iconOnly?: boolean;
    }>(),
    {
        iconOnly: false,
    }
);
const { eventId } = toRefs(props);

const modalStore = useModalStore();
const userStore = useUserStore();
const eventsStore = useEventsStore();

const { user, savedEvents } = storeToRefs(userStore);

const isSaved = computed(() => {
    if (user.value) {
        return savedEvents.value.includes(eventId.value);
    }

    return false;
});

const submit = async() => {
    if (!user.value) {
        modalStore.open(MODAL_FREE_ACCOUNT_SIGNUP);
        return;
    }

    await useFetchLaravel(`/v2.0/user/me/favorite/${eventId.value}`, {
        method: 'POST',
    });

    eventsStore.updateMyListHome();

    await refreshNuxtData(USER_STORE_DATA_KEY_USER_EVENTS);
};
</script>
